import { useAppContext } from "@src/autoDebit/AppContext";
import message from "@src/autoDebit/message";
import { useMemo } from "react";
import styles from "./index.module.css";

const localeLinkMap = {
  en: "/autodebit/assets/en/steps.pdf",
  pt: "/autodebit/assets/pt/steps.pdf",
  zh: "/autodebit/assets/zh/steps.pdf",
};

const Note = () => {
  const { intl, locale } = useAppContext();
  const link = useMemo(() => {
    return localeLinkMap[locale as keyof typeof localeLinkMap];
  }, [locale]);
  if (locale === "ja") return null;
  return (
    <div className={`${styles.wrap} auto-debit-content-wrapper`}>
      <span className={styles.title}>
        {intl.formatMessage(message["Note.Title"])}
      </span>
      <p className={styles.content}>
        {intl.formatMessage(message.Note)}
        <a
          className={styles.link}
          rel="noopener noreferrer"
          href={link}
          target="_blank"
        >
          {intl.formatMessage(message.NoteLink)}
        </a>
      </p>
    </div>
  );
};

export default Note;
